import { AcordoStatus } from "../enums";
import { OperacaoEnum } from "resources/enums/conta";
import { RelatorioBaseData } from "core/features/relatorios/typings";
import { PaginateQuery } from "resources/types/shared";

export interface AcordoItem {
  id: string;
  diasEmAtraso: number;
  status: AcordoStatus;
  createdAt: string;
  unidade: {
    blocoQuadra: string;
    numero: string;
  };
  parcelasPaga: number;
  parcelasAberta: number;
  valor: number;
  valorPago: number;
  dataCancelamento: string;
  dataPagamento: string;
  codigo?: number;
  importado?: boolean;
}

export interface AcordosDashboard {
  emAberto: number;
  cancelados: number;
  renegociados: number;
  pagos: number;
  encerrados: number;
}

export interface DividaAcordo {
  id: string;
  dataVencimento: string;
  valor: number;
  valorJuros: number;
  valorMulta: number;
  valorHonorarios: number;
  valorTotal: number;
}

export interface ParcelaAcordo {
  id: string;
  numero: number;
  dataVencimento: string;
  valor: number;
  valorPago: number | null;
  dataRenegociacao?: string;
  deletedAt?: string | null;
}
export interface EntradaAcordo {
  id: string;
  valor: number;
  formaPagamento: {
    id: string;
    nome: string;
  };
  deletedAt?: string | null;
}

export interface AcordoDetails {
  id: string;
  unidade: {
    id: string;
    numero: string;
    blocoQuadra: string;
  };
  morador: {
    id: string;
    nome: string;
  };
  novoAcordoId?: string;
  codigo?: number;
  entrada: EntradaAcordo | null;
  parcelas: ParcelaAcordo[];
  dividasAcordo: DividaAcordo[];
  createdAt: string;
  status: AcordoStatus;
  dataCancelamento: string;
  diasEmAtraso: number;
  dataPagamento: string;
}

export interface ParcelasAcordoType {
  index: number;
  parcela: number | string;
  vencimento: string;
  pagamento: number;
  id: string;
  dataVencimento: string;
  valor: number | null;
  valorPago: number | null;
}

export interface AcordoContaItem {
  index: string;
  codigo: string | number;
  divida: number;
  pago: number;
  abertura: string;
  cancelamento: string | null;
  parcelas: ParcelasAcordoType[];
  createdAt: string;
  dataCancelamento: null | string;
  diasEmAtraso: number;
  id: string;
  parcelasAberta: number;
  parcelasPaga: number;
  status: string;
  valor: number | null;
  valorPago: number;
}

export interface UseAcordosProps {
  page: number;
  limit: number;
  search?: string;
  unidadeId?: string | undefined;
}

export interface FormAcordoComposicao {
  categoriaFinanceiraId: string;
  descricao?: string;
  alterarCategoria?: string;
  valor: number;
  operacao: OperacaoEnum;
  alterarParaCategoriaId?: string;
  added?: boolean;
  tempId?: string;
}

export interface FormAcordoParcela {
  numeroParcela: number;
  dataVencimento: string;
  valor: number;
}

export interface FormAcordo {
  contas: string[];
  desconto: number;
  dataPrimeiraParcela: string;
  quantidadeParcela: number;
  gerarBoletoAutomatico: boolean;
  enviarBoletoEmail: boolean;
  entrada: {
    formaRecebimentoId: string;
    valor: number;
    contaBancariaId: string;
    dataVencimento?: string;
  } | null;
  composicoes: FormAcordoComposicao[];
  parcelas: FormAcordoParcela[];
  taxaJurosMensal?: number;
  taxaMulta?: number;
  unidadeId: string;
  pessoaResponsavelId: string;
  temEntrada?: boolean;
}

export interface FormAcordoPorComposicoes extends Omit<FormAcordo, "contas"> {
  contaComposicaoIds: string[];
}

export enum ExportarAcordoEvents {
  ExportarPDF = "Acordo_Exportar_PDF",
  ExportarExcel = "Acordo_Exportar_Excel",
}

export type PDFAcordoResponse = RelatorioBaseData & AcordoDetails;

export interface FiltroAcordos extends PaginateQuery {
  unidadeId?: string;
  dataInicio?: string;
  dataFim?: string;
  status?: AcordoStatus | undefined;
}
